<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M32 17a1 1 0 001 1h5a1 1 0 000-2h-5a1 1 0 00-1 1z"/><path d="M42 10h-4V6a2 2 0 00-2-2H12a2 2 0 00-2 2v4H6a2 2 0 00-2 2v24a2 2 0 002 2h4v4a2 2 0 002 2h24a2 2 0 002-2v-4h4a2 2 0 002-2V12a2 2 0 00-2-2zM13 7h22v3H13zm22 28v6H13V27h22zm6 0h-3v-8.09a1.5 1.5 0 00-.5-2.91h-27a1.5 1.5 0 00-.5 2.91V35H7V13h34z"/><path d="M17 32h14a1 1 0 000-2H17a1 1 0 000 2zM17 38h14a1 1 0 000-2H17a1 1 0 000 2z"/></svg>